import { createBaseApi } from 'store/api';

export const api = createBaseApi({
  reducerPath: 'configService',
});
